import "@emotion/react";
function f(n) {
  if (n.screenX !== 0 || n.screenY !== 0) {
    n.preventDefault();
    const t = n.target;
    t.blur(), t.parentNode && t.parentNode.blur();
  }
}
function p(n, t) {
  return function(o) {
    t && o.stopPropagation(), f(o), n && n(o);
  };
}
const h = (n) => {
  const t = Math.floor(n), o = Math.floor(n / 60), e = t - o * 60, i = e < 10 ? "0" + e : e;
  return `${o}:${i}`;
};
function g(n) {
  const t = n % 60, o = (n - t) / 60;
  return (o > 0 ? o + " minute" : "") + (o > 1 ? "s" : "") + (t > 0 && o > 0 ? " and " : "") + (t > 0 ? t + " second" : "") + (t > 1 ? "s" : "");
}
function w(n, t) {
  if (n && n.platform && ["iPad", "iPhone"].includes(n.platform))
    return t;
}
function m(n) {
  if (!n)
    return {};
  const { top: t, right: o, bottom: e, left: i, width: c, height: r, x: u, y: d } = n.getBoundingClientRect();
  return { top: t, right: o, bottom: e, left: i, width: c, height: r, x: u, y: d };
}
function y(n) {
  if (!n)
    return {};
  const t = n.getBoundingClientRect();
  let { top: o, y: e } = t;
  const { right: i, bottom: c, left: r, width: u, height: d, x: s } = t;
  return o += window.scrollY, e += window.scrollY, { top: o, right: i, bottom: c, left: r, width: u, height: d, x: s, y: e };
}
function S() {
  return typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
}
function b(n) {
  return function(o) {
    if (o.type === "keydown" && ["Enter", " "].includes(o.key))
      return n(o);
  };
}
const C = () => {
};
let l = 0;
const M = (n = "") => `${n}${l++}`, B = (n, t, o) => Math.max(n, Math.min(t, o));
export {
  f as blurIfClick,
  S as canUseDOM,
  B as clamp,
  w as forIOS,
  h as formatSecondsToMinutesAndSeconds,
  g as formatSecondsToMinutesAndSecondsVerbose,
  m as getBoundingClientRect,
  y as getBoundingClientRectWithoutScroll,
  b as handleButtonRoleKeyDown,
  p as handleClick,
  C as noop,
  M as uniqueId
};
